<template>
  <b-tab title="Avulsos" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE SERVIÇOS AVULSOS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterAvulsos(filtro)" :fields="fields.avulso">
        <template #cell(concluido)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ conclusao(data.item) }}
            </p>
          </div>
        </template>

        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="10" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="avulso-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Filtre pela descrição do serviço."
              v-model="filtro"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <avulso-modal ref="editorAvulso" />
      <confirm-modal ref="confirmAvulso" :descricao="'Deseja realmente remover o serviço ?'" @executar="executar()" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useAvulsoStore } from "@/stores/AvulsoStore";
import Avulso from "@/models/Avulso";
import TableFields from "@/tools/TableFields";
import AvulsoModal from "@/components/modals/atividade/AvulsoModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";

export default {
  name: "AvulsoTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: "",
      avulso: new Avulso(0, "Novo Serviço", new Date(), false, false),
    };
  },

  components: {
    "avulso-modal": AvulsoModal,
    "confirm-modal": ConfirmModal,
  },

  methods: {
    adicionar() {
      this.avulso = new Avulso(0, "Novo Serviço", new Date(), false, false);
      this.$refs.editorAvulso.call(this.avulso);
    },

    editar(avulso) {
      this.$refs.editorAvulso.call(avulso);
    },

    deletar(avulso) {
      this.avulso.update(avulso);
      this.$refs.confirmAvulso.call();
    },

    conclusao(avulso) {
      if (avulso.concluido) {
        return "Sim";
      } else {
        return "Não";
      }
    },

    executar() {
      this.avulsoStore.REMOVER_AVULSO(this.avulso.id);
    },
  },

  setup() {
    const store = useSgcqStore();
    const avulsoStore = useAvulsoStore();
    const { getFilterAvulsos } = storeToRefs(avulsoStore);

    return {
      store,
      avulsoStore,
      getFilterAvulsos,
    };
  },
};
</script>

<style lang="scss" scoped>
#avulso-filter {
  width: 30rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
